
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host {

    display:block;
}

:host([site='BH']) .views-exposed-form.views-exposed-form {

    margin:0px;
}

:host([site='BH']) .views-exposed-form.views-exposed-form {

    width:100%;
}

:host([site='BH']) .views-exposed-form.views-exposed-form {

    border-style:none;
}

:host([site='BH']) .views-exposed-form.views-exposed-form {

    padding:0px;
}

:host([site='BH']) .views-exposed-form.views-exposed-form {

    --tw-shadow:0 0 #0000;

    --tw-shadow-colored:0 0 #0000;

    box-shadow:0 0 #0000, 0 0 #0000, 0 0 #0000;

    box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

:host([site='BH']) form.views-exposed-form {

    position:relative;
}

:host([site='BH']) form.views-exposed-form {

    display:block;
}

:host([site='BH']) .claro-autocomplete {

    width:100%;
}

:host([site='BH']) label, :host([site='BH']) .form-item__label {

    margin-top:0px;
}

:host([site='BH']) label, :host([site='BH']) .form-item__label {

    font-family:var(--bh-ff-body);
}

:host([site='BH']) label, :host([site='BH']) .form-item__label {

    font-size:var(--fs-base);

    line-height:var(--lh-base);
}

:host([site='BH']) label, :host([site='BH']) .form-item__label {

    font-weight:var(--fw-semibold);
}

:host([site='BH']) label, :host([site='BH']) .form-item__label {

    color:var(--bh-neutral-darker);
}

:host([site='BH']) input[type='text'] {

    width:100%;
}

:host([site='BH']) input[type='text'] {

    border-radius:0.5rem;
}

:host([site='BH']) input[type='text'] {

    border-width:1px;
}

:host([site='BH']) input[type='text'] {

    border-color:var(--bh-neutral-dark);
}

:host([site='BH']) input[type='text'] {

    background-color:var(--bh-neutral-white);
}

:host([site='BH']) input[type='text'] {

    background-image:none;
}

:host([site='BH']) input[type='text'] {

    font-family:var(--bh-ff-body);
}

:host([site='BH']) input[type='text'] {

    color:var(--bh-neutral-darker);
}

:host([site='BH']) input[type='text'] {

    padding-right:3rem !important;
}

:host([site='BH']) input[type='text']{

    padding:calc(1.25rem - 1px);
  }

:host([site='BH']) input[type='text']::placeholder {

    color:var(--bh-neutral-dark);
}

:host([site='BH']) input[type='text']:hover {

    border-width:2px;
}

:host([site='BH']) input[type='text']:hover {

    border-color:var(--bh-brand-primary-default);
}

:host([site='BH']) input[type='text']:hover {

    --tw-shadow:0 0 #0000;

    --tw-shadow-colored:0 0 #0000;

    box-shadow:0 0 #0000, 0 0 #0000, 0 0 #0000;

    box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

:host([site='BH']) input[type='text']:hover{
      padding:calc(1.25rem - 2px);
    }

:host([site='BH']) input[type='text']:focus {

    border-width:2px;
}

:host([site='BH']) input[type='text']:focus {

    border-color:var(--bh-brand-primary-default);
}

:host([site='BH']) input[type='text']:focus{
    }

:host([site='BH']) input[type='text']:focus {

    --tw-shadow:0 0 #0000 !important;

    --tw-shadow-colored:0 0 #0000 !important;

    box-shadow:0 0 #0000, 0 0 #0000, 0 0 #0000 !important;

    box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

:host([site='BH']) input[type='text']:focus{
      padding:calc(1.25rem - 2px);
    }

:host([site='BH']) input[type='text']:focus-visible {

    outline:2px solid transparent;

    outline-offset:2px;
}

:host([site='BH']) input[type='text'].error {

    border-width:2px;
}

:host([site='BH']) input[type='text'].error {

    border-color:var(--bh-status-danger);
}

:host([site='BH']) input[type='text'].error {

    padding:1.25rem;
}

:host([site='BH']) .form-item {

    margin:0px;
}

:host([site='BH']) .form-actions {

    position:absolute;
}

:host([site='BH']) .form-actions {

    right:0px;
}

:host([site='BH']) .form-actions {

    bottom:0px;
}

:host([site='BH']) .form-actions {

    margin:0px;
}

:host([site='BH']) .form-actions {

    display:flex;
}

:host([site='BH']) .form-actions {

    height:4rem;
}

:host([site='BH']) .form-actions {

    align-items:center;
}

:host([site='BH']) .form-actions {

    justify-content:center;
}

:host([site='BH']) .form-actions {

    padding:0.5rem;
}

:host([site='BH']) .form-actions input[type='submit'] {

    margin:0px;
}

:host([site='BH']) .form-actions input[type='submit'] {

    height:2.5rem;
}

:host([site='BH']) .form-actions input[type='submit'] {

    width:2.5rem;
}

:host([site='BH']) .form-actions input[type='submit'] {

    background-color:var(--neutral-transparent);
}

:host([site='BH']) .form-actions input[type='submit'] {

    background-position:center;
}

:host([site='BH']) .form-actions input[type='submit'] {

    background-repeat:no-repeat;
}

:host([site='BH']) .form-actions input[type='submit'] {

    padding:0px;
}

:host([site='BH']) .form-actions input[type='submit'] {

    font-size:0px;
}

:host([site='BH']) .form-actions input[type='submit'] {

    --tw-shadow:0 0 #0000;

    --tw-shadow-colored:0 0 #0000;

    box-shadow:0 0 #0000, 0 0 #0000, 0 0 #0000;

    box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

:host([site='BH']) .form-actions input[type='submit']{

    background-size:27px;
    background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='28' height='27' viewBox='0 0 28 27' fill='none'%3E%3Cpath d='M17.9382 15.75H17.0495L16.7345 15.4462C18.0845 13.8712 18.782 11.7225 18.3995 9.43872C17.8707 6.31122 15.2607 3.81372 12.1107 3.43122C7.35195 2.84622 3.34695 6.85122 3.93195 11.61C4.31445 14.76 6.81195 17.37 9.93945 17.8987C12.2232 18.2812 14.372 17.5837 15.947 16.2337L16.2507 16.5487V17.4375L21.032 22.2187C21.4932 22.68 22.247 22.68 22.7082 22.2187C23.1695 21.7575 23.1695 21.0037 22.7082 20.5425L17.9382 15.75ZM11.1882 15.75C8.38695 15.75 6.1257 13.4887 6.1257 10.6875C6.1257 7.88622 8.38695 5.62497 11.1882 5.62497C13.9895 5.62497 16.2507 7.88622 16.2507 10.6875C16.2507 13.4887 13.9895 15.75 11.1882 15.75Z' fill='%23004E7A'/%3E%3C/svg%3E");
  }

:host([site='BH']) .form-type--search-api-autocomplete .is-autocompleting{
    background:inherit;
  }

:host([site='BH']) .form-type--search-api-autocomplete .claro-autocomplete__message {

    position:absolute;
}

:host([site='BH']) .form-type--search-api-autocomplete .claro-autocomplete__message {

    right:1rem;
}

:host([site='BH']) .form-type--search-api-autocomplete .claro-autocomplete__message {

    top:-1.5rem;
}

:host([site='BH']) .form-type--search-api-autocomplete .claro-autocomplete__message {

    font-size:var(--fs-xs);

    line-height:var(--lh-xs);
}

:host([site='BH']) .form-type--search-api-autocomplete .claro-autocomplete__message {

    font-weight:var(--fw-normal);
}

:host([site='BH']) .form-type--search-api-autocomplete .claro-autocomplete__message {

    color:var(--neutral-gray-1);
}

:host([site='BH']) input[type='reset']{
    display:none;
  }
`;